import React from "react";
import {Typography} from "@material-ui/core";
import {Translate} from "@material-ui/icons";
import clsx from "clsx";
import FlexBox from "view/components/Layout/FlexBox";
import CountryFlag from "view/components/CountryFlag";
import type {ShowLanguage} from "view/components/SettingsRows/ShowLanguagesRow/useShowLanguages";
import useStyles from "./styles";

type Props = {
  languages: ShowLanguage[];
  currentCode: string;
  defaultCode?: string;
  onSelect: (code: string) => void;
  id?: string;
};

const LocalisationPreviewLanguageBar = ({
  languages,
  currentCode,
  defaultCode,
  onSelect,
  id = "preview-language-bar",
}: Props) => {
  const classes = useStyles();

  if (languages.length < 2) return null;

  return (
    <FlexBox alignCenter className={classes.previewBar} id={id}>
      <FlexBox alignCenter gap={1}>
        <Translate color="primary" className={classes.headerIcon} />
        <Typography variant="h3" color="primary">
          Localisation
        </Typography>
      </FlexBox>

      {languages.map((language) => {
        const isSelected = language.code === currentCode;

        return (
          <button
            key={language.code}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onSelect(language.code)}
            className={clsx(
              classes.previewChip,
              isSelected && classes.previewChipSelected
            )}
          >
            <CountryFlag size="small" flagEmoji={language.flagEmoji} />
            <span>
              {language.code === defaultCode
                ? `Default (${language.name})`
                : language.name}
            </span>
          </button>
        );
      })}
    </FlexBox>
  );
};

export default LocalisationPreviewLanguageBar;
